"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetcher = fetcher;
var _axios = require("@ori/axios");
var _models = require("../models");
async function fetcher(url, options) {
  const {
    tenant,
    token,
    ...config
  } = options;
  const headers = {
    ...config.headers,
    authorization: token,
    'x-tenant-context': tenant
  };
  return _axios.axios.get(`${url}`, {
    ...config,
    headers
  }).then(({
    data: result
  }) => result).catch(error => {
    throw new _models.ApiError(error.message, error);
  });
}